// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IXq0","right":"styles_right__3NOAZ"};